import type { CountryKey, Testimonial } from "~/types";

type LocaleSpecificTestimonials = Partial<Record<"home" | CountryKey, Testimonial[]>>;

export default function useTestimonials(key: "home" | CountryKey) {
  const { tm, rt } = useI18n();

  const testimonials = getTestimonialMessages(key);
  if (key !== "home") {
    testimonials.push(...getLocaleSpecificTestimonials());
  }

  return {
    testimonials,
  };

  function getTestimonialMessages(key: "home" | CountryKey): Testimonial[] {
    const messages = tm(`testimonials.${key}`) as Testimonial[] | undefined;
    return Array.isArray(messages) ? messages.map(buildTestimonial) : [];
  }

  function buildTestimonial(testimonial: Testimonial): Testimonial {
    return {
      ...testimonial,
      name: String(rt(testimonial.name)),
      body: String(rt(testimonial.body)),
      date: String(rt(testimonial.date)),
      img: String(rt(testimonial.img)),
      url: String(rt(testimonial.url)),
      ...(testimonial.stacked !== undefined && { stacked: testimonial.stacked }),
    };
  }

  function getLocaleSpecificTestimonials(): Testimonial[] {
    const localeSpecificTestimonials = tm("partials.testimonials.locale_specific") as LocaleSpecificTestimonials;
    return (localeSpecificTestimonials?.[key as CountryKey] || []).map(buildTestimonial);
  }
}
